
// Translation file for reusable components

export const components = {
  // Button labels
  buttons: {
    details: "Részletek",
    save: "Mentés",
    cancel: "Mégse",
    delete: "Törlés",
    edit: "Szerkesztés",
    back: "Vissza",
    next: "Tovább",
    submit: "Beküldés",
    export: "Exportálás",
    add: "Hozzáadás",
  },
  
  // Common card elements
  cards: {
    balance: {
      title: "Aktuális egyenleged",
      description: "Minden héten utalunk, ha egyenleged eléri az 1000 Ft-ot!",
      explanation: "Egyenleged működése"
    }
  },
  
  // Status labels
  status: {
    active: "Aktív",
    inactive: "Inaktív",
    new: "Új",
    accepted: "Elfogadva",
    completed: "Teljesítve",
    rejected: "Elutasítva"
  },
};
